import { getConfigureByCode } from 'api'

import { registerStoreItem } from 'utils/storeCreator'

let store = registerStoreItem({
  store: {
    namespaced: true
  },
  name: 'config',
  api: getConfigureByCode,
  handle: data => {
    try {
      return {
        ...data.data,
        content: JSON.parse(data.data.content)
      }
    } catch (e) {
      return data.data
    }
  },
  defaultValue() {
    return null
  }
})

export default {
  name: 'commonConfig',
  store
}
